import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';

import type { AgeRange, AvatarSortKey } from '../useAvatarFilters';
import AgeRangeSlider from './AgeRangeSlider';
import GenderCheckboxes from './GenderCheckboxes';

const FilterPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border: 1px solid ${colors.neutral20};
  border-radius: 8px;
  background-color: ${colors.white};
`;

const SortSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SortLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.bigBangBlack};
`;

const caretIcon = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M4 6l4 4 4-4' stroke='${colors.bigBangBlack.replace(
  '#',
  '%23'
)}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`;

const SortSelect = styled.select`
  /* Native select arrows can't be styled, so hide them and draw our own caret */
  appearance: none;
  padding: 8px 36px 8px 12px;
  border: 1px solid ${colors.neutral20};
  border-radius: 6px;
  font-family: inherit;
  font-size: 13px;
  background: #fff ${caretIcon} no-repeat right 12px center;
  background-size: 16px;
  width: 100%;
  cursor: pointer;
`;

type AvatarFilterSidebarProps = {
  ageBounds: AgeRange;
  ageRange: AgeRange;
  onAgeRangeChange: (range: AgeRange) => void;
  genderOptions: Array<{ value: string; display: string }>;
  selectedGenders: string[];
  onToggleGender: (gender: string) => void;
  sortKey: AvatarSortKey;
  onSortChange: (sortKey: AvatarSortKey) => void;
};

const AvatarFilterSidebar = ({
  ageBounds,
  ageRange,
  onAgeRangeChange,
  genderOptions,
  selectedGenders,
  onToggleGender,
  sortKey,
  onSortChange
}: AvatarFilterSidebarProps) => (
  <FilterPanel>
    <Text variant="body1Semibold">Filter</Text>
    <SortSection>
      <SortLabel htmlFor="avatarSort">Sort by</SortLabel>
      <SortSelect
        id="avatarSort"
        value={sortKey}
        onChange={event => onSortChange(event.target.value as AvatarSortKey)}
      >
        <option value="age_asc">Age (low to high)</option>
        <option value="age_desc">Age (high to low)</option>
      </SortSelect>
    </SortSection>
    <AgeRangeSlider bounds={ageBounds} value={ageRange} onChange={onAgeRangeChange} />
    <GenderCheckboxes
      options={genderOptions}
      selected={selectedGenders}
      onToggle={onToggleGender}
    />
  </FilterPanel>
);

export default AvatarFilterSidebar;
